






import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import blackLogo from 'images/padlet_logo_black.svg'
import rainbowLogo from 'images/padlet_logo_rainbow.png'
import whiteLogo from 'images/padlet_logo_white.svg'

const browser = namespace('browser')

@Component
export default class PadletLogo extends Vue {
  rainbowLogo = rainbowLogo
  blackLogo = blackLogo
  whiteLogo = whiteLogo
  @browser.State darkMode
}
